export class DeleteShapeUnit {
    constructor(shape) {
        this.shape = shape;
        this.diagram = shape.diagram;
        this.title = 'Deletion';
    }
    undo() {
        this.diagram._addShape(this.shape, false);
        this.shape.select(false);
    }
    redo() {
        this.shape.select(false);
        this.diagram.remove(this.shape, false);
    }
}
